import { useContext } from 'react'
import { useParams } from 'react-router-dom'

import { AddActionDialog } from '@pages/EntityCreateOrEdit'

import { CATEGORIES, ENTITY_TYPES_REQUEST } from '@constants'

import { PageContext } from '../AddMenuPointDialog'

export const AddMenuPointActionDialog = () => {
  const {
    handlers: { handleCloseAddActionDialog, handleChangeAction },
    state: { showAddActionDialog, addActionDialogData },
  } = useContext(PageContext)

  const { id: contextMenuId } = useParams()

  if (!addActionDialogData) {
    return null
  }

  return (
    <AddActionDialog
      isDisableActionEventsFiltering
      actionEventsCategoryCode={CATEGORIES.BINDING_CONTEXT_MENU_POINT_EVENTS_ACTION}
      actionTable={addActionDialogData.actionTable}
      bindingValuesAction={addActionDialogData.bindingValuesAction}
      columns={addActionDialogData?.columns}
      createAction={handleChangeAction}
      currentRow={addActionDialogData.currentRow}
      editAction={handleChangeAction}
      modalType={addActionDialogData.modalType}
      objectCode={addActionDialogData.objectCode}
      showDialog={showAddActionDialog}
      variablesConfig={{
        entityType: ENTITY_TYPES_REQUEST.CONTEXT_MENU,
        entityId: contextMenuId,
      }}
      onCloseModal={handleCloseAddActionDialog}
    />
  )
}
